export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-600 text-xs font-medium mb-4">
              随时随地追剧
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-4">
              手机也能畅享高清追剧
            </h2>
            <p className="text-foreground-500 text-sm leading-relaxed mb-8 max-w-md mx-auto lg:mx-0">
              情侣影院全面适配移动端浏览器，无需下载任何App即可在手机上流畅观看所有电视剧全集。
              躺在床上、窝在沙发、通勤路上——随时随地打开浏览器，就能和TA一起追最新韩剧和国产剧。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors"
              >
                <i className="ri-smartphone-line text-lg"></i>
                手机端体验
              </a>
              <a
                href="#features"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-secondary-300 text-foreground-600 font-medium text-sm hover:bg-secondary-100 transition-colors"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多功能
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6">
              <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-check-line text-accent-500"></i>
                <span>无需下载</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-check-line text-accent-500"></i>
                <span>浏览器即开即看</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-check-line text-accent-500"></i>
                <span>1080P高清</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-check-line text-accent-500"></i>
                <span>省流量模式</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[360px] lg:max-w-none">
            <div className="relative">
              <div className="bg-background-50 rounded-[2.5rem] p-3 border-4 border-secondary-300 shadow-lg max-w-[300px] mx-auto">
                <div className="bg-foreground-800 rounded-[2rem] overflow-hidden">
                  <div className="h-8 bg-foreground-900 flex items-center justify-center">
                    <div className="w-16 h-1 rounded-full bg-foreground-600"></div>
                  </div>
                  <div className="p-3">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-7 h-7 rounded-lg bg-primary-500 flex items-center justify-center">
                        <i className="ri-heart-fill text-white text-xs"></i>
                      </div>
                      <span className="text-white text-xs font-heading font-bold">情侣影院</span>
                    </div>
                    <div className="space-y-2">
                      <div className="bg-foreground-700 rounded-lg p-2 flex items-center gap-2">
                        <div className="w-12 h-8 rounded bg-accent-500 flex-shrink-0"></div>
                        <div className="flex-1 min-w-0">
                          <div className="text-white text-[10px] font-medium truncate">你比星光美丽</div>
                          <div className="text-foreground-300 text-[8px]">第36集 · 1080P</div>
                        </div>
                        <i className="ri-play-fill text-primary-400 text-sm"></i>
                      </div>
                      <div className="bg-foreground-700 rounded-lg p-2 flex items-center gap-2">
                        <div className="w-12 h-8 rounded bg-primary-500 flex-shrink-0"></div>
                        <div className="flex-1 min-w-0">
                          <div className="text-white text-[10px] font-medium truncate">眼泪女王</div>
                          <div className="text-foreground-300 text-[8px]">全16集 · 韩语中字</div>
                        </div>
                        <i className="ri-play-fill text-primary-400 text-sm"></i>
                      </div>
                      <div className="bg-foreground-700 rounded-lg p-2 flex items-center gap-2">
                        <div className="w-12 h-8 rounded bg-secondary-400 flex-shrink-0"></div>
                        <div className="flex-1 min-w-0">
                          <div className="text-white text-[10px] font-medium truncate">与凤行</div>
                          <div className="text-foreground-300 text-[8px]">全39集 · 4K修复</div>
                        </div>
                        <i className="ri-play-fill text-primary-400 text-sm"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}